//@flow
import type { TableColumnTypes } from 'common/entity/generic/EntityImportContainer/types';
import TransporterImportHelper from './TransporterImportHelper';

const TRANSPORTER_IMPORT_FORMAT: Array<TableColumnTypes> = [
    {
        titleKey: 'masterTransporterProperties.id',
        id: 'id',
        disabled: true,
        fixed: true,
        required: true,
        templateValue: 'masterImportTemplateValues.masterTransporter.id'
    },
    {
        titleKey: 'masterTransporterProperties.code',
        id: 'code',
        disabled: true,
        templateValue: 'masterImportTemplateValues.masterTransporter.code'
    },
    {
        titleKey: 'masterTransporterProperties.name',
        id: 'name',
        required: true,
        templateValue: 'masterImportTemplateValues.masterTransporter.name'
    },
    {
        titleKey: 'masterTransporterProperties.isActive',
        id: 'isActive',
        required: true,
        templateValue: 'masterImportTemplateValues.masterTransporter.isActive',
        validateCell: TransporterImportHelper.getBooleanValidator(),
        processCell: TransporterImportHelper.getBooleanProcessor()
    },
    {
        titleKey: 'masterTransporterProperties.registeredName',
        id: 'registeredName',
        required: true,
        templateValue:
            'masterImportTemplateValues.masterTransporter.registeredName'
    },
    {
        titleKey: 'masterTransporterProperties.tagline',
        id: 'tagline',
        templateValue: 'masterImportTemplateValues.masterTransporter.tagline'
    },
    {
        titleKey: 'masterTransporterProperties.type',
        id: 'type',
        required: true,
        templateValue: 'masterImportTemplateValues.masterTransporter.type',
        processCell: TransporterImportHelper.processUpperCaseId
    },
    {
        titleKey: 'masterTransporterProperties.phoneNumber',
        id: 'phoneNumber',
        accessor: ['phoneNumber', 'phoneNumber'],
        templateValue:
            'masterImportTemplateValues.masterTransporter.phoneNumber'
    },
    {
        titleKey: 'masterTransporterProperties.additionalPhoneNumbers',
        id: 'additionalPhoneNumbers',
        accessor: ['additionalPhoneNumbers'],
        templateValue:
            'masterImportTemplateValues.masterTransporter.additionalPhoneNumbers',
        processCell: TransporterImportHelper.processAdditionalPhoneNumbers,
        serializeCell: TransporterImportHelper.serializeAdditionalPhoneNumbers
    },
    {
        titleKey: 'masterTransporterProperties.emailAddress',
        id: 'emailAddress',
        accessor: ['emailAddress', 'emailAddress'],
        templateValue:
            'masterImportTemplateValues.masterTransporter.emailAddress',
        validateCell: TransporterImportHelper.validateEmailAddress
    },
    {
        titleKey: 'masterTransporterProperties.teamId',
        id: 'teamId',
        accessor: ['teams'],
        required: true,
        templateValue: 'masterImportTemplateValues.masterTransporter.teams',
        processCell: TransporterImportHelper.processTeams,
        validateCell: TransporterImportHelper.validateTeamIds,
        serializeCell: TransporterImportHelper.serializeTeams
    },
    {
        titleKey: 'masterTransporterProperties.address.placeName',
        id: 'placeName',
        accessor: ['address', 'placeName'],
        templateValue:
            'masterImportTemplateValues.masterLocation.address.placeName'
    },
    {
        titleKey: 'masterTransporterProperties.address.address',
        id: 'formattedAddress',
        accessor: ['address', 'formattedAddress'],
        required: true,
        templateValue:
            'masterImportTemplateValues.masterLocation.address.address'
    },
    {
        titleKey: 'masterTransporterProperties.address.locality',
        id: 'localityName',
        accessor: ['address', 'localityName'],
        templateValue:
            'masterImportTemplateValues.masterLocation.address.locality'
    },
    {
        titleKey: 'masterTransporterProperties.address.city',
        id: 'city',
        accessor: ['address', 'city'],
        templateValue: 'masterImportTemplateValues.masterLocation.address.city'
    },
    {
        titleKey: 'masterTransporterProperties.address.state',
        id: 'state',
        accessor: ['address', 'state'],
        templateValue: 'masterImportTemplateValues.masterLocation.address.state'
    },
    {
        titleKey: 'masterTransporterProperties.address.pincode',
        id: 'pincode',
        accessor: ['address', 'pincode'],
        templateValue:
            'masterImportTemplateValues.masterLocation.address.pincode'
    },
    {
        titleKey: 'masterTransporterProperties.address.country',
        id: 'countryCode',
        accessor: ['address', 'countryCode'],
        required: true,
        templateValue:
            'masterImportTemplateValues.masterLocation.address.country',
        validateCell: TransporterImportHelper.validateCountryCode
    },
    {
        titleKey: 'masterLocationProperties.contactId',
        id: 'contactId',
        templateValue: 'masterImportTemplateValues.masterLocation.contactId',
        accessor: ['contactId', 'contactId'],
        validateCellAsync: ({
            entity,
            header,
            onSuccess,
            onFailure,
            validateContactIds,
            clientId,
            t
        }) => {
            TransporterImportHelper.validateEntityIdAsync({
                validator: validateContactIds,
                entityNameId: 'contact',
                clientId,
                onSuccess,
                onFailure,
                entity,
                header,
                t
            });
        },
        serializeCell: TransporterImportHelper.serializeContactId,
        getModelFieldAccessor: TransporterImportHelper.getContactIdAccessor
    }
];

export default TRANSPORTER_IMPORT_FORMAT;
